import Swiper, { Autoplay, Pagination, Parallax, EffectFade } from 'swiper'
import 'swiper/modules/parallax/parallax.scss'
import 'swiper/modules/effect-fade/effect-fade.scss'


document.addEventListener('DOMContentLoaded', () => {
  const sliderWrappers = document.querySelectorAll('.mtt-text-image-slider')

  if (sliderWrappers.length > 0) {
    sliderWrappers.forEach(sliderWrapper => {
      const swiperElement = sliderWrapper
      const pagination = sliderWrapper.querySelector('.swiper-pagination')
      const speed = 700

      const swiperOptions = {
        modules: [ Autoplay, Pagination, Parallax, EffectFade ],
        effect: 'fade',
        allowTouchMove: false,
        grabCursor: false,
        speed: speed,
        slidesPerView: 1,
        threshold: 8,
        loop: true,
        parallax: true,
        autoHeight: false,
        fadeEffect: {
          crossFade: true
        },
        pagination: {
          el: pagination,
          clickable: true,
        },
      }

      const swiper = new Swiper(swiperElement, swiperOptions)

      swiperElement.addEventListener('mouseenter', function () {
        swiper.autoplay.stop();
      })

      swiperElement.addEventListener('mouseleave', function () {
        swiper.autoplay.start();
      })

    })
  }
})